import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["loading", "disabled", "invalid", "inline", "rightAdornment", "size", "width", "minWidth", "maxWidth", "dateInputRef"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { InputWrapper } from '../../../../internal/components/InputWrapper';
import { NativeTimeInput } from '../NativeTimeInput';
import * as styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var TimeInputInput = /*#__PURE__*/React.forwardRef(function TimeInputInput(props, ref) {
  var loading = props.loading,
    disabled = props.disabled,
    invalid = props.invalid,
    inline = props.inline,
    rightAdornment = props.rightAdornment,
    size = props.size,
    width = props.width,
    minWidth = props.minWidth,
    maxWidth = props.maxWidth,
    dateInputRef = props.dateInputRef,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(InputWrapper, {
    ref: ref,
    loading: loading,
    disabled: disabled,
    inline: inline,
    invalid: invalid,
    size: size,
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth,
    className: styles['wrapper'],
    children: /*#__PURE__*/_jsx(NativeTimeInput, _objectSpread(_objectSpread({}, rest), {}, {
      ref: dateInputRef,
      className: styles['input-time']
    }))
  });
});